export default __webpack_public_path__ + "static/MIA_group_of_compnies-b56ced91c3486f96cf4b6b8d0f431bcf.jpg";